import { render, staticRenderFns } from "./AudioParser.vue?vue&type=template&id=560eab12"
import script from "./AudioParser.vue?vue&type=script&lang=js"
export * from "./AudioParser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports